<form>
	<ui-modal modalTitle="Delete Labour Type" size="md">
		<ng-container *ngIf="replacements">
			<p>
				<strong>{{description}}</strong> is used by
				<strong>{{productCount}}</strong> product{{productCount === 1 ? '' : 's'}}.
			</p>

			<div class="d-flex selectable">
				<div class="px-2 py-3">
					<label class="custom-control custom-radio">
						<input type="radio" class="custom-control-input" name="labourDeleteAction" [value]="'replace'" [(ngModel)]="action" [ngModelOptions]="{ standalone: true }" [disabled]="disabled || !replacements.length">
						<span class="custom-control-label"></span>
					</label>
				</div>

				<div class="flex-weight-1 mb-2 border rounded" [ngClass]="{ dimmed: action !== 'replace' }"
					(click)="replacements.length && !disabled && (action = 'replace')">

					<div class="p-3">
						<b>Delete and replace</b>
						<div class="text-secondary">Replace this labour type with another across all {{productCount}} product{{productCount === 1 ? '' : 's'}}, then delete it.</div>
					</div>

					<div class="px-3 pb-3">
						<ui-form labelWidth="10rem">
							<ui-form-control label="Replacement">
								<select class="form-control" [(ngModel)]="replacementId" [ngModelOptions]="{ standalone: true }" [disabled]="disabled">
									<option [ngValue]="null">-- Select labour type --</option>
									<option *ngFor="let t of replacements" [ngValue]="t.id">{{t.description}}</option>
								</select>
							</ui-form-control>
						</ui-form>

						<div *ngIf="selectedReplacement" class="alert alert-info m-0">
							<strong>{{description}}</strong> will be replaced by <strong>{{selectedReplacement.description}}</strong>
							across <strong>{{productCount}}</strong> product{{productCount === 1 ? '' : 's'}}.
						</div>

						<div *ngIf="!replacements.length" class="text-secondary">
							No other active labour types are available.
						</div>
					</div>
				</div>
			</div>

			<div class="d-flex selectable">
				<div class="px-2 py-3">
					<label class="custom-control custom-radio">
						<input type="radio" class="custom-control-input" name="labourDeleteAction" [value]="'delete'" [(ngModel)]="action" [ngModelOptions]="{ standalone: true }" [disabled]="disabled">
						<span class="custom-control-label"></span>
					</label>
				</div>

				<div class="flex-weight-1 mb-2 border rounded" [ngClass]="{ dimmed: action !== 'delete' }"
					(click)="!disabled && (action = 'delete')">

					<div class="p-3">
						<b>Delete</b>
						<div class="text-secondary">Delete this labour type without replacing it.</div>
					</div>

					<div class="px-3 pb-3">
						<div class="text-secondary">Products using this labour type will still reference it after deletion.</div>
					</div>
				</div>
			</div>

			<div class="alert alert-warning mt-3">
				<div><i class="wq wq-warning mr-1"></i><strong>{{description}} will be deleted.</strong></div>
				<div>This action cannot be undone.</div>
			</div>
		</ng-container>

		<button type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="button" class="btn btn-danger" (click)="submit()" [disabled]="disabled || (action === 'replace' && !replacementId)" ui-modal-footer>Delete</button>
	</ui-modal>
</form>
